// extracted by mini-css-extract-plugin
export default {"container":"pp-z","ratingLayout":"qp-z","ratingLabel":"rp-z","nonInteractiveRatingLabel":"sp-z"};